var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10,10-4.48,10-10S17.52,2,12,2Zm0,16.75c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25,.56,1.25,1.25-.56,1.25-1.25,1.25Zm3.91-8.07c-.17,.38-.38,.71-.64,.98-.26,.27-.54,.51-.83,.72-.29,.21-.57,.4-.83,.59-.26,.19-.48,.39-.64,.62-.17,.22-.25,.48-.25,.78v.41h-1.6v-.44c0-.44,.08-.81,.24-1.12s.37-.59,.62-.84c.25-.25,.52-.47,.81-.68,.29-.21,.56-.43,.81-.66s.46-.48,.62-.77,.25-.62,.25-1-.1-.76-.29-1.1c-.19-.34-.48-.61-.85-.82-.37-.21-.82-.31-1.35-.31-.49,0-.93,.09-1.32,.28s-.69,.45-.92,.79c-.22,.34-.34,.74-.34,1.2,0,.17,.02,.34,.05,.5,.04,.17,.09,.34,.17,.52l-1.56,.55c-.11-.26-.2-.52-.25-.79-.05-.26-.08-.52-.08-.79,0-.77,.19-1.44,.57-2.02,.38-.57,.89-1.02,1.53-1.34,.64-.32,1.36-.48,2.15-.48,.88,0,1.62,.17,2.25,.51,.62,.34,1.1,.8,1.44,1.38,.34,.58,.5,1.22,.5,1.93,0,.55-.08,1.01-.25,1.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionCircle);
export default __webpack_public_path__ + "static/1772534745/media/icon-question-circle.8226017750dbc7b7bf2c779a8bced7e1.svg";
export { ForwardRef as ReactComponent };